import { BlockColor } from "./enums";

export const BlockColorMap = {
  [BlockColor.BLUE]: "bg-[#AEC6DF]",
  [BlockColor.ORANGE]: "bg-[#A1A1A3]",
  [BlockColor.PURPLE]: "bg-[#BA9DF8]",
};

export const BulletpointColorMap = {
  [BlockColor.BLUE]: "[&_li]:before:bg-[#AEC6DF]",
  [BlockColor.ORANGE]: "[&_li]:before:bg-[#A1A1A3]",
  [BlockColor.PURPLE]: "[&_li]:before:bg-[#BA9DF8]",
};
